/**
 * @author 戴旭
 * @createDate 2023/02/28 15:27:19
 * @updateDate 2023/02/28 15:27:19
 * @description: 基础信息
 */

const baseInfoRouter = [

  // 人员管理
  {
    path: '/jurisdictionSystem/account-manage',
    name: 'accountManage',
    component: () =>
      import(
        /*webpackChunkName:"account" */
        // '@/views/jurisdictionSystem/account/Manage.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/Page.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '人员管理'
    }
  },

  // 人员管理 体验账号管理
  {
    path: '/jurisdictionSystem/test-account',
    name: 'testAccount',
    component: () =>
      import(
        /*webpackChunkName:"testAccount" */
        // '@/views/jurisdictionSystem/account/Test.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/test-account/Page.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '体验账号管理',
      breadcrumb: [
        {
          title: '人员管理',
          name: 'accountManage'
        }
      ]
    }
  },


  // 添加编辑体验账号 meta_type 1-添加 2-编辑
  {
    path: '/jurisdictionSystem/test-account-edit/:meta_type/:account_id',
    name: 'testAccountEdit',
    component: () =>
      import(
        /*webpackChunkName:"testAccount" */
        // '@/views/jurisdictionSystem/account/TestAccountEdit.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/test-account/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加体验账号',
        breadcrumb: [
          {
            title: '人员管理',
            name: 'accountManage'
          },
          {
            title: '体验账号管理',
            name: 'testAccount'
          }
        ]
      },
      2: {
        title: '编辑体验账号',
        breadcrumb: [
          {
            title: '人员管理',
            name: 'accountManage'
          },
          {
            title: '体验账号管理',
            name: 'testAccount'
          }
        ]
      }
    }
  },


  // 操作记录
  {
    path: '/jurisdictionSystem/test-account-log',
    name: 'testAccountLog',
    component: () =>
      import(
        /*webpackChunkName:"testAccountLog" */
        // '@/views/jurisdictionSystem/account/TestLog.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/test-account/Log.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '操作记录',
      breadcrumb: [
        {
          title: '人员管理',
          name: 'accountManage'
        },
        {
          title: '体验账号管理',
          name: 'testAccount'
        }
      ]
    }
  },


  // 人员管理 批量导入人员列表
  {
    path: '/jurisdictionSystem/account-import',
    name: 'accountImport',
    component: () =>
      import(
        /*webpackChunkName:"account" */
        // '@/views/jurisdictionSystem/account/ClientImport.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/Import.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '批量导入更新注销',
      breadcrumb: [
        {
          title: '人员管理',
          name: 'accountManage'
        }
      ]
    }
  },


  // 人员管理 已注销账号
  {
    path: '/jurisdictionSystem/account-stopped',
    name: 'accountCancel',
    component: () =>
      import(
        /*webpackChunkName:"account" */
        // '@/views/jurisdictionSystem/account/Stopped.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/stop-account/Page.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '已注销账号',
      breadcrumb: [
        {
          title: '人员管理',
          name: 'accountManage'
        }
      ]
    }
  },


  // 人员管理 微信绑定
  {
    path: '/jurisdictionSystem/account-bind-wechat',
    name: 'accountBindWechat',
    component: () =>
      import(
        /*webpackChunkName:"account" */
        // '@/views/jurisdictionSystem/account/BindWechat.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/account/bind-wx/Page.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '微信绑定',
      breadcrumb: [
        {
          title: '人员管理',
          name: 'accountManage'
        }
      ]
    }
  },


  // 备案代表
  {
    path: '/jurisdictionSystem/account-record',
    name: 'accountRecord',
    component: () =>
      import(
        /*webpackChunkName:"accountRecord" */
        // '@/views/jurisdictionSystem/accountRecord/Index'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/behalf-record/Page.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '备案代表'
    }
  },


  // 备案代表编辑 meta_type 1-添加 2-编辑
  {
    path: '/jurisdictionSystem/account-record-edit/:meta_type/:id',
    name: 'accountRecordEdit',
    component: () =>
      import(
        /*webpackChunkName:"accountRecordEdit" */
        // '@/views/jurisdictionSystem/accountRecord/Edit'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/behalf-record/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      1: {
        title: '添加备案代表',
        breadcrumb: [
          {
            title: '备案代表',
            name: 'accountRecord'
          }
        ]
      },
      2: {
        title: '编辑备案代表',
        breadcrumb: [
          {
            title: '备案代表',
            name: 'accountRecord'
          },
          {
            title: '备案代表详情',
            name: 'accountRecordDetail'
          }
        ]
      }
    }
  },


  // 备案代表导入
  {
    path: '/jurisdictionSystem/account-record-import',
    name: 'accountRecordImport',
    component: () =>
      import(
        /*webpackChunkName:"accountRecordImport" */
        // '@/views/jurisdictionSystem/accountRecord/Import'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/behalf-record/Import.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '批量导入',
      breadcrumb: [
        {
          title: '备案代表',
          name: 'accountRecord'
        }
      ]
    }
  },


  // 备案代表详情
  {
    path: '/jurisdictionSystem/account-record-detail/:id',
    name: 'accountRecordDetail',
    component: () =>
      import(
        /*webpackChunkName:"accountRecordDetail" */
        // '@/views/jurisdictionSystem/accountRecord/Detail'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/behalf-record/Detail.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '备案代表详情',
      breadcrumb: [
        {
          title: '备案代表',
          name: 'accountRecord'
        }
      ]
    }
  },


  // 部门标签配置
  {
    path: '/jurisdictionSystem/department-label-config',
    name: 'departmentLabelConfig',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/department/LabelConfig.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/base-info/deptLabels/Page.vue'
        ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '部门标签配置'
    }
  }


];

export default baseInfoRouter;
